export default "/images/vendor/flag-icon-css/flags/4x3/cp.svg?f7c7739a330c16f18fcd916a852b8bdd";